import api from '../_api';

export const institutionService = {
  getStats(id, range) {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return api.get(`/institution/${id}/stats_range/`, {
      params: { range, userTimezone },
    });
  },
  getSalesOverview(id) {
    return api.get(`/institution/${id}/sales_overview/`);
  },
  getDeviceOpens(id, range) {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    return api.get(`/institution/${id}/device_stats_range/`, {
      params: { range, userTimezone },
    });
  },
  getCustomSalesOverview(url, range) {
    return api.get(url, { params: { range } });
  },
  getTemplates(id) {
    return api.get(`/institution/${id}/templates/`);
  },
};
